import {Page} from '../../../shared/model/core/page.model';

export abstract class RootConverter<Src, Target> {

    public convert(src: Src): Target {
        if (!src) {
            return null;
        }
        return this.doConversion(src);
    }

    public convertFromArray(items: Src[]): Target[] {
        if (!items) {
            return null;
        }
        return items.map(value => this.doConversion(value));
    }



    public convertFromPage(src: Page<Src>): Page<Target> {
        if (!src) {
            return Page.empty();
        }
        const target = Object.assign(new Page<Target>(), src);
        target.content = [];
        src.content.forEach((value) => {
            target.content.push(this.doConversion(value));
        });
        return target;
    }

    protected abstract doConversion(src: Src): Target;

}
